import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import ProjectsListPage from "@/components/settings/projects/projects-list-page";
import { userIdSearchSchema } from "@/lib/search/user-id-search";

const ProjectsIndexPage = (): JSX.Element => {
	const { userId } = Route.useSearch();
	return <ProjectsListPage focusUserId={userId} kind="project" />;
};

export const Route = createFileRoute("/_app/settings/projects/")({
	validateSearch: userIdSearchSchema,
	component: ProjectsIndexPage,
});
